import { ICluster, IClusterListResponse } from "@nkr/models/index";
import { AuthActionCreators } from "@nkr/store/authorization";
import { useAppHookContext } from "@nkr/utils/rest-api";
import { useEffect, useState } from "react";

interface IRetVal {
    list: ICluster[],
    loading: boolean, 
    error: string
}

export interface ISwapQuery {
    status?: number[],
    chainStatus?: number[],
    matchStatus?: number[],
    chains?: number[],
    donors?: number[],
    fromCourierVendor?: boolean,
    courierVendor?: number
}

function useSwapQuery(query?: ISwapQuery): IRetVal {

    const { dispatch } = useAppHookContext();
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string>('');
    const [list, setList] = useState<ICluster[]>([]);

    useEffect(() => {
        if(query) {
            setLoading(true);
            setError('');

            const fetchData = async () => {
                var config = {
                    //this seems abnormal but that's how this API endpoint was designed
                    url: `${__API__}/swap/query?q=${JSON.stringify(query)}` 
                };

                try {
                    const response:IClusterListResponse = await dispatch(AuthActionCreators.apiGet(config));
                    
                    if(response && response.data.results && response.data.success) {
                        setList(response.data.results);
                    } else {
                        setError('Unable to load data');
                        setList([]);     
                    }
                } catch (err) {
                    setList([]);
                    setError(err);
                    console.error(err);
                } finally {
                    setLoading(false);
                }
            }

            fetchData();
        }
    }, [query]);
    
    return { list, loading, error }
}

export default useSwapQuery;
